import classNames from 'classnames'

function DotIndicators({
  size,
  activeIndex,
  classNameIndicatorDots,
  classNameActiveDot,
  classNameIndicators,
  classNameWrapper,
  variant,
  OnClickDot,
}) {
  let indicators = []
  for (let id = 0; id < size; id++) {
    indicators.push(
      <div
        key={id}
        className={classNames(
          'h-1.5 w-1.5 bg-white opacity-20 mx-2 my-0 p-0 rounded-[50%] border-[none] outline-hidden lg:w-1.5 lg:h-1.5 group-data-[variant="onWhite"]:mx-[3px] group-data-[variant="onWhite"]:bg-white-150 group-data-[variant="onWhite"]:opacity-100! group-data-[variant="fdr"]:bg-neutral-150 group-data-[variant="fdr"]:opacity-100! z-10',

          {
            [classNameIndicatorDots]: Boolean(classNameIndicatorDots),
            // Active state
            'opacity-100! bg-[#30f]!': activeIndex === id, // on-indicator
            'group-data-[variant="onWhite"]:bg-[#3b6af7] group-data-[variant="onWhite"]:opacity-100 group-data-[variant="fdr"]:bg-[#154199]! group-data-[variant="fdr"]:opacity-100':
              activeIndex === id,
            [classNameActiveDot]: Boolean(classNameActiveDot) && activeIndex === id,
          }
        )}
        data-active={activeIndex === id}
        data-testid={`dot-indicator-dot-${id}`}
        onClick={typeof OnClickDot === 'function' ? () => OnClickDot(id) : undefined}
      />
    )
  }

  return (
    <div
      data-variant={variant}
      className={classNames(
        'flex justify-center items-center w-full z-1 relative',
        'group',
        classNameIndicators
      )}
      role="group"
      data-testid="dot-indicator-container"
    >
      {variant === 'onWhite' ? (
        <div
          className={classNames(
            'z-1 px-[4px] py-1 rounded-[10px] bg-[#5C708A4D] w-fit flex justify-center items-center relative mt-[32px]',
            classNameWrapper
          )}
        >
          {indicators}
        </div>
      ) : (
        indicators
      )}
    </div>
  )
}

export { DotIndicators }
